import React from 'react';
import { ImageProps } from '.';

const SvgZigzagBiBasic = ({ size = 130, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 4.0625)) || 32} fill='none' viewBox='0 0 130 32' {...props}>
      <g fill='#121314' clipPath='url(#ZigzagBIBasic_svg__a)'>
        <path d='M.52.573v7.21h8.902L0 31.427h20.458V24.2h-8.835L20.977.573H.519ZM58.607.573v7.21h8.903l-9.422 23.643h20.458V24.2H69.71L79.065.573H58.607ZM31.276.573h-7.954v30.853h7.954V.573ZM106.481 31.427h-7.98l-1.271-5.466h-8.078l-1.271 5.466H79.9L88.308.573h9.808l8.365 30.853-.001.001ZM95.657 19.2 93.19 8.59 90.723 19.2h4.934ZM45.7 13.708h11.95c.135 1.057.18 2.072.18 3.041C57.83 25.961 54.12 32 45.928 32s-12.402-5.597-12.402-16c0-10.402 4.39-16 12.31-16 5.714 0 9.198 2.87 10.999 8.315L49.715 10.8c-.8-2.08-1.893-3.454-3.838-3.454-2.48 0-4.171 1.954-4.171 8.3 0 6.348 1.221 9.257 4.357 9.257 1.99 0 3.405-1.235 3.405-4.584H45.7v-6.612.001ZM117.87 13.708h11.949c.136 1.057.182 2.072.182 3.041 0 9.212-3.712 15.251-11.904 15.251s-12.402-5.597-12.402-16c0-10.402 4.39-16 12.311-16 5.713 0 9.197 2.87 10.998 8.315l-7.119 2.485c-.8-2.08-1.893-3.454-3.838-3.454-2.479 0-4.171 1.954-4.171 8.3 0 6.348 1.221 9.257 4.357 9.257 1.991 0 3.405-1.235 3.405-4.584h-3.768v-6.612.001Z' />
      </g>
      <defs>
        <clipPath id='ZigzagBIBasic_svg__a'>
          <path fill='#fff' d='M0 0h130v32H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgZigzagBiBasic;
